import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CHATEAUX } from '../chateau-component/chateau';

@Component({
  selector: 'app-accueil',
  imports: [RouterLink],
  templateUrl: './accueil.html',
})
export class Accueil implements OnInit, OnDestroy {
  @ViewChild('carouselContainer') carouselContainer!: ElementRef<HTMLElement>;
  photos = CHATEAUX;
  currentSlide = 0;
  atEnd = false; // le carrousel ne peut plus défiler vers la droite
  private timer?: ReturnType<typeof setInterval>;

  ngOnInit() {
    this.startAutoPlay();
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  startAutoPlay() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.scrollToSlide(this.atEnd ? 0 : this.currentSlide + 1);
    }, 3000);
  }

  // Clic sur une flèche : on change de photo et on relance les 3 secondes.
  goTo(index: number) {
    this.scrollToSlide(index);
    this.startAutoPlay();
  }

  scrollToSlide(index: number) {
    this.currentSlide = index;
    const container = this.carouselContainer.nativeElement;
    const slide = container.children[index] as HTMLElement | undefined;
    if (slide) {
      container.scrollTo({ left: slide.offsetLeft - container.offsetLeft, behavior: 'smooth' });
    }
  }

  // Suit le défilement (au doigt ou automatique) pour afficher les bonnes flèches.
  onScroll() {
    const container = this.carouselContainer.nativeElement;
    const slides = Array.from(container.children) as HTMLElement[];
    const distance = (s: HTMLElement) =>
      Math.abs(s.offsetLeft - container.offsetLeft - container.scrollLeft);
    this.currentSlide = slides.reduce((best, s, i) => (distance(s) < distance(slides[best]) ? i : best), 0);
    this.atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
  }
}
